export const state = {
  initialLoadCompleted: 0,
  auth: null,
  axiosError: null,
  submitting: false,
  online: true,
  axiosQueue: [],
  chunkState: {
    total: 0,
    processed: 0
  },
  axiosTiming: {},
  users: {},
  usersStore: [],
  usersState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    }
  },
  roles: {},
  rolesState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    }
  },
  budgets: {},
  budgetsStore: [],
  budgetsState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'label',
      dir: 'asc'
    }
  },
  fundBalances: {},
  fundBalancesState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'label',
      dir: 'asc'
    }
  },
  budgetBalances: {},
  budgetBalancesState: {
    tableRows: 10,
    page: 1,
    filters: {},
    sort: {
      col: 'label',
      dir: 'asc'
    }
  },
  funds: {},
  fundsStore: [],
  fundsState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'label',
      dir: 'asc'
    }
  },
  tags: {},
  tagsStore: [],
  tagsState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'label',
      dir: 'asc'
    }
  },
  feeds: {},
  feedsStore: [],
  feedsState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'label',
      dir: 'asc'
    }
  },
  bankFeeds: {},
  bankFeedsState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'created_at',
      dir: 'desc'
    },
    search: {
      active: false,
      phrase: ''
    }
  },
  transactions: {},
  transactionsState: {
    tableRows: 20,
    page: 1,
    filters: {},
    sort: {
      col: 'created_at',
      dir: 'desc'
    }
  }
}
